var _g, _circle, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRemoveCardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 74,
    viewBox: "0 0 81 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1231_222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.4324 24.5131C41.2087 24.1255 41.148 23.6649 41.2639 23.2326C41.3797 22.8003 41.6625 22.4317 42.0501 22.2079L47.8958 18.8329C48.2834 18.6091 48.744 18.5485 49.1763 18.6643C49.6086 18.7802 49.9772 19.063 50.2009 19.4506L51.8884 22.3734C52.1122 22.761 52.1729 23.2216 52.057 23.6539C51.9412 24.0862 51.6584 24.4548 51.2708 24.6786L45.4251 28.0536C45.0375 28.2774 44.5769 28.338 44.1446 28.2222C43.7123 28.1063 43.3437 27.8235 43.1199 27.4359L41.4324 24.5131Z",
    fill: "#1E8B7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.22067 29.4707C7.6703 30.3658 6.53901 31.8401 6.07567 33.5693C5.61233 35.2985 5.85489 37.141 6.75 38.6913L20.25 62.074C21.1451 63.6244 22.6194 64.7557 24.3486 65.219C26.0779 65.6824 27.9203 65.4398 29.4707 64.5447L64.5447 44.2947C66.0951 43.3996 67.2264 41.9253 67.6897 40.1961C68.153 38.4668 67.9105 36.6244 67.0154 35.074L53.5154 11.6913C52.6203 10.141 51.1459 9.00969 49.4167 8.54635C47.6875 8.083 45.8451 8.32557 44.2947 9.22067L9.22067 29.4707ZM50.5925 13.3788L59.03 27.993L18.1103 51.618L9.67284 37.0038C9.22528 36.2287 9.104 35.3074 9.33567 34.4428C9.56734 33.5782 10.133 32.8411 10.9082 32.3935L45.9822 12.1435C46.7574 11.696 47.6786 11.5747 48.5432 11.8063C49.4078 12.038 50.145 12.6037 50.5925 13.3788ZM62.8572 41.3719L27.7832 61.6219C27.008 62.0694 26.0868 62.1907 25.2222 61.959C24.3576 61.7274 23.6204 61.1617 23.1728 60.3865L21.4853 57.4637L62.405 33.8387L64.0925 36.7615C64.5401 37.5367 64.6614 38.4579 64.4297 39.3225C64.198 40.1871 63.6324 40.9243 62.8572 41.3719Z",
    fill: "#1E8B7C"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 41,
    r: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63 25.25C54.225 25.25 47.25 32.225 47.25 41C47.25 49.775 54.225 56.75 63 56.75C71.775 56.75 78.75 49.775 78.75 41C78.75 32.225 71.775 25.25 63 25.25ZM69.075 48.875L63 42.8L56.925 48.875L55.125 47.075L61.2 41L55.125 34.925L56.925 33.125L63 39.2L69.075 33.125L70.875 34.925L64.8 41L70.875 47.075L69.075 48.875Z",
    fill: "#1E8B7C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1231_222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white",
    transform: "translate(0 27) rotate(-30)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveCardIcon);
export default __webpack_public_path__ + "static/media/remove-card-icon.2c3e02b1.svg";
export { ForwardRef as ReactComponent };